/**
 * activation key
 * customer firstname
 * customer lastname
 * customer e-mail
 */

import Component from 'vue-class-component';
import { Vue } from 'vue-property-decorator';

@Component
export default class Copy2Clipboard extends Vue {
  public tooltip = 'Copy';
  public showCopied = false;

  doCopy() {
    const text = this.$slots.default[0].text?.trim();

    navigator.clipboard.writeText(text).then(
      () => {
        this.showCopied = true;
        this.tooltip = 'Copied';
        setTimeout(() => {
          this.showCopied = false;
          this.tooltip = 'Copy';
        }, 2000);
      }, 
      () => {
        this.tooltip = 'Can not copy';
      }
    );
  }
}
